import AnalyticCard from "../../analyticCard/analyticCard";

const DriversCards = () => {
    return(
        <ul className="analytics-card-box grid col-4">
            <AnalyticCard data={{number: 23, title: <span>Risky<br/> Drivers</span>}}/>
            <AnalyticCard color={'#5E98FF'}
                          backColor={'#F5F5F5'}
                          data={{number: '4.0', title: <span>Average<br/> Score</span>}}/>
            <AnalyticCard color={'#36BA6E'}
                          backColor={'#E3F5EA'}
                          data={{number: 349, title: <span>Active<br/> Drivers</span>}}/>
            <AnalyticCard color={'#5E98FF'}
                          backColor={'#EFF7FF'}
                          data={{number: '03', title: <span>Inactive
                          <br/>Driver</span>}}/>
        </ul>
    )
}

export default DriversCards;
